import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const StatusPill = ({ className, type = "default", children }) => {
  return (
    <span className={classNames("status-pill", type, className)}>
      {children}
    </span>
  );
};

StatusPill.propTypes = {
  type: PropTypes.oneOf(["primary", "secondary", "default"]),
};

export default StatusPill;
